import React, { useContext, useState, useRef, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Switch from "@material-ui/core/Switch";

import { InventoryContext } from "../contexts/InventoryContext";
import { ScreenContext } from "../contexts/ScreenContext";

const FormDialog = ({ open, handleClose, formAction, selectedRowData }) => {
  const { saveInventoryItem } = useContext(InventoryContext);
  const { setSnackbarMessage } = useContext(ScreenContext);

  const [itemID, setitemID] = useState(0);
  const [itemAction, setitemAction] = useState("Update");
  const [itemName, setitemName] = useState("");
  const [itemDesc, setitemDesc] = useState("");
  const [itemClient, setitemClient] = useState("");
  const [itemNotes, setitemNotes] = useState("");
  const [itemLocation, setitemLocation] = useState("");
  const [itemQty, setitemQty] = useState(0);
  const [itemCP, setitemCP] = useState(0);
  const [itemSP, setitemSP] = useState(0);
  const [status, setStatus] = useState(true);
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [localImageURL, setlocalImageURL] = useState("");
  const ImageUploadRef = useRef();

  const closeDialog = () => {
    setitemSP(0);
    setitemQty(0);
    handleClose();
  };

  const handleSave = () => {
    let fdata = {
      formAction: formAction,
      id: itemID,
      action: itemAction,
      name: itemName,
      desc: itemDesc,
      client: itemClient,
      notes: itemNotes,
      location: itemLocation,
      qty: itemAction === "Sell" ? -itemQty : itemQty,
      cp: itemCP,
      sp: itemSP,
      status: status,
      image: localImageURL,
    };


    saveInventoryItem(fdata, selectedFile);
    handleClose();
  };

  const handleFileSelected = (event) => {
    setSelectedFile();
    setIsFilePicked(false);
    const file = event.target.files[0];
    if (file.type.match("image.*")) {
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
      let imgURL = URL.createObjectURL(event.target.files[0]);
      setlocalImageURL(imgURL);

    } else {
      event.target.value = null;
      setSnackbarMessage({ message: "Wrong file type, please use image only!", severity: 'error' });
    }
  };

  useEffect(() => {
    if (selectedRowData && itemAction === "Update") {
      setitemName(selectedRowData.ItemName);
      setitemDesc(selectedRowData.ItemDescription);
      setitemLocation(selectedRowData.ItemLocation);
      setitemCP(selectedRowData.ItemCostPrice);
      setStatus(selectedRowData.ItemStatus);
      setitemQty(selectedRowData.ItemQty);
    } else {
      setitemQty(0);
      setitemCP(0);
      setitemSP(0);
    }

    if (selectedRowData && formAction === "Edit") {
      setitemID(selectedRowData.id);
      setitemName(selectedRowData.ItemName);
      setitemDesc(selectedRowData.ItemDescription);
      setitemLocation(selectedRowData.ItemLocation);
      setitemCP(selectedRowData.ItemCostPrice);
      setStatus(selectedRowData.ItemStatus);
      setlocalImageURL(
        typeof selectedRowData.ItemImage === "undefined"
          ? null
          : selectedRowData.ItemImage
      );
      setIsFilePicked(
        typeof selectedRowData.ItemImage === "undefined" ? false : true
      );
    } else {
      setitemID(0);
      setitemName("");
      setitemDesc("");
      setitemLocation("");
      setitemClient("");
      setitemQty(0);
      setitemCP(0);
      setitemSP(0);
      setStatus(true);
      setIsFilePicked(false);
      setlocalImageURL(null);
    }

    if (!open) {
      setitemAction("Update");
      setitemClient("");
      setitemNotes("");
    }

    // alert(`formAction: ${formAction} itemAction: ${itemAction}`);


  }, [selectedRowData, formAction, open, itemAction]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={closeDialog}
        aria-labelledby="form-dialog-title"
        disableEnforceFocus={true}
      >
        <DialogTitle id="form-dialog-title">{`${formAction} Item`}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill in all the required fields.
          </DialogContentText>

          {formAction === "Edit" && (
            <FormControl component="fieldset">
              <FormLabel component="legend">Action</FormLabel>
              <RadioGroup
                row
                aria-label="position"
                name="position"
                defaultValue="Update"
                onChange={(e) => {
                  setitemAction(e.target.value);
                }}
              >
                <FormControlLabel
                  value="Update"
                  control={<Radio color="primary" />}
                  label="Update Details"
                  labelPlacement="start"
                />

                <FormControlLabel
                  value="Purchase"
                  control={<Radio color="primary" />}
                  label="Purchase"
                  labelPlacement="start"
                />
                <FormControlLabel
                  value="Sell"
                  control={<Radio color="primary" />}
                  label="Sell"
                  labelPlacement="start"
                />
              </RadioGroup>
            </FormControl>
          )}

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                autoFocus
                margin="dense"
                id="itemName"
                name="itemName"
                label="Item Name"
                type="text"
                value={itemName}
                autoComplete="off"
                onChange={(e) => {
                  setitemName(e.target.value);
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                margin="dense"
                id="itemLocation"
                name="itemLocation"
                label="Item Location"
                type="text"
                value={itemLocation}
                autoComplete="off"
                onChange={(e) => {
                  setitemLocation(e.target.value);
                }}
                fullWidth
              />
            </Grid>
          </Grid>

          <FormGroup row>
            <TextField
              margin="dense"
              id="itemDescription"
              name="itemDescription"
              label="Item Description"
              type="text"
              value={itemDesc}
              autoComplete="off"
              onChange={(e) => {
                setitemDesc(e.target.value);
              }}
              fullWidth
            />
          </FormGroup>

          {itemAction === "Sell" ? (
            <FormGroup row>
              <TextField
                margin="dense"
                id="itemClient"
                name="itemClient"
                label="Client"
                type="text"
                value={itemClient}
                autoComplete="off"
                onChange={(e) => {
                  setitemClient(e.target.value);
                }}
                fullWidth
              />
            </FormGroup>
          ) : null}

          <FormGroup row>
            <TextField
              margin="dense"
              id="itemNotes"
              name="itemNotes"
              label="Notes"
              type="text"
              value={itemNotes}
              autoComplete="off"
              onChange={(e) => {
                setitemNotes(e.target.value);
              }}
              fullWidth
            />
          </FormGroup>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              {itemAction === "Sell" ? (
                <TextField
                  margin="dense"
                  id="itemSellingPrice"
                  name="itemSellingPrice"
                  label="Item Selling Price"
                  type="number"
                  value={itemSP}
                  autoComplete="off"
                  onChange={(e) => {
                    setitemSP(e.target.value);
                  }}
                  fullWidth
                />
              ) : (
                <TextField
                  margin="dense"
                  id="itemCostPrice"
                  name="itemCostPrice"
                  label="Item Cost Price"
                  type="number"
                  value={itemCP}
                  autoComplete="off"
                  onChange={(e) => {
                    setitemCP(e.target.value);
                  }}
                  fullWidth
                />
              )}
            </Grid>
            {(formAction === "New" ||
              itemAction === "Sell" ||
              itemAction === "Purchase") && (
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  id="itemQty"
                  name="itemQty"
                  label="Item Qty"
                  type="number"
                  value={itemQty}
                  autoComplete="off"
                  onChange={(e) => {
                    setitemQty(e.target.value);
                  }}
                  fullWidth
                />
              </Grid>
            )}
          </Grid>

          {(formAction === "New" || itemAction === "Update") && (
            <FormGroup row style={{ marginTop: 10 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={status}
                    onChange={(e) => {
                      setStatus(e.target.checked);
                    }}
                    name="status"
                    color="primary"
                  />
                }
                label="Active"
              />
            </FormGroup>
          )}

          {(formAction === "New" || itemAction === "Update") && (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                {isFilePicked ? (
                  <div>
                    <img
                      id="ItemImage"
                      src={localImageURL}
                      alt="Item image"
                      style={{ height: 80 }}
                    />
                  </div>
                ) : (
                  <p>Select a file to show details</p>
                )}
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  component="label"
                  color="primary"
                  style={{ marginTop: 10 }}
                >
                  Add Image
                  <input
                    type="file"
                    id="inventory-image-upload"
                    name="inventoryImage"
                    ref={ImageUploadRef}
                    hidden
                    onChange={handleFileSelected}
                    accept="image/*"
                  />
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FormDialog;
